import { useEffect, useState } from "react";
import { Category } from "../../home";
import axios from "axios";

import { IconTrashFilled, IconPencilBolt } from "@tabler/icons-react";
import Swal from "sweetalert2";

const AdminCategory = () => {
  const [origin, setOrigin] = useState<Category[] | null>(null);
  const [category, setCategory] = useState<Category[] | null>(null);
  const [plus, setPlus] = useState(false);
  const [newName, setNewName] = useState("");

  useEffect(() => {
    axios
      .get(`/api/category`)
      .then((res) => {
        if (res.data.code === "0000") {
          setCategory(res.data.data);
          setOrigin(res.data.data);
        }
      })
      .catch((e) => console.error(e));
  }, []);

  const categoryDeleteFnc = (id: number) => {
    if (!window.confirm("정말로 삭제하시겠습니까?")) {
      return false;
    }
    axios
      .delete(`/api/category/${id}`)
      .then((res) => {
        if (res.data.code === "0000") {
          Swal.fire({
            title: "카테고리 삭제 완료",
            text: "카테고리 삭제가 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/admin/category"));
        }
      })
      .catch((e) => {
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/admin/category"));
      });
  };

  const categoryUpdateFnc = (id: number) => {
    if (!window.confirm("수정하시겠습니까?")) {
      return false;
    }

    axios
      .put(`/api/category`, {
        id: id,
        name: category![id - 1].name,
      })
      .then((res) => {
        if (res.data.code === "0000") {
          Swal.fire({
            title: "카테고리 수정 완료",
            text: "카테고리 수정이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/admin/category"));
        }
      })
      .catch((e) => {
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/admin/category"));
      });
  };

  const categorySaveFnc = () => {
    axios
      .post(`/api/category`, { name: newName })
      .then((res) => {
        if (res.data.code === "0000") {
          Swal.fire({
            title: "카테고리 등록 완료",
            text: "카테고리 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/admin/category"));
        }
      })
      .catch((e) => {
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/admin/category"));
      });
  };

  return (
    <div className=" relative w-full h-full">
      <div className="relative w-full h-full flex justify-between items-center">
        <h4>카테고리</h4>
        <button
          className=" relative w-fit h-fit bg-primary text-white rounded-md px-5 py-0.5"
          onClick={() => setPlus(true)}
        >
          추가하기
        </button>
      </div>
      <div className="relative w-full h-full bg-white border shadow-md py-5 px-4 rounded-lg my-3">
        <div className=" relative w-full h-full grid grid-cols-7 text-center border-b py-3 px-2">
          <p>번호</p>
          <p className="col-span-4">이름</p>
          <p>수정</p>
          <p>삭제</p>
        </div>
        {category &&
          category.map((v, i) => (
            <div
              key={i}
              className=" relative w-full h-full grid grid-cols-7 items-center text-center border-b py-3 px-2"
            >
              <p>{v.id}</p>
              <input
                type="text"
                defaultValue={v.name}
                onChange={(e) => {
                  const newValue = [...category];
                  newValue[v.id - 1].name = e.target.value;
                  setCategory(newValue);
                }}
                className="col-span-4"
              />
              <IconPencilBolt
                onClick={() => categoryUpdateFnc(v.id)}
                className="mx-auto hover:text-black cursor-pointer"
              />
              <IconTrashFilled
                onClick={() => categoryDeleteFnc(v.id)}
                className="mx-auto hover:text-black cursor-pointer"
              />
            </div>
          ))}
        {plus && (
          <div className=" relative w-full h-full grid grid-cols-7 items-center text-center border-b py-3 px-2">
            <p>{(category?.length || 0) + 1}</p>
            <input
              type="text"
              defaultValue={""}
              onChange={(e) => setNewName(e.target.value)}
              className="col-span-4"
            />
            <button
              onClick={categorySaveFnc}
              className=" relative w-fit h-fit border border-primary text-primary rounded-md px-5 pt-0.5 mx-auto"
            >
              <p>등록</p>
            </button>
          </div>
        )}
        {/* <div className=" relative w-fit h-fit mx-auto mt-10">
            {total > 0 && (
              <Pagination
                total={Math.ceil(total / 10)}
                value={page}
                onChange={setPage}
                color="gray"
              />
            )}
          </div> */}
      </div>
    </div>
  );
};

export default AdminCategory;
